import * as React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import { useState } from 'react';
import moment from 'moment';

import ThresholdSettings from '../thresholdSettings';
import { WorldSettings } from '../../../../services/config/config';

import '../settings.css';

export interface IProps {
  worldSettings: WorldSettings,
  submitInProgress: boolean,
  timeStamp: number,
  onDataChanged: (data: WorldSettings) => void,
  disabled?: boolean
}

const ns = 'settings' as const;

export function BatteryHealthSettings(props: IProps) {
  const { t } = useTranslation(ns);
  const [alertTimeStamp, setAlertTimeStamp] = useState<number>(props.timeStamp);

  if (props.timeStamp > alertTimeStamp) {
    setAlertTimeStamp(props.timeStamp);
  }

  function onDataChanged(data: number, field: 'warning' | 'problem') {
    if (field === 'warning') {
      props.onDataChanged({ ...props.worldSettings, batteryHealthStatusYellow: data });
    } else {
      props.onDataChanged({ ...props.worldSettings, batteryHealthStatusRed: data });
    }
  }

  function onAlertToggled(data: boolean, initialSettings: { warning: number, problem: number }) {
    setAlertTimeStamp(moment.utc().valueOf());
    props.onDataChanged({
      ...props.worldSettings,
      batteryHealthStatusEnabled: data,
      batteryHealthStatusYellow: initialSettings.warning,
      batteryHealthStatusRed: initialSettings.problem,
    });
  }

  return (
    <ThresholdSettings
      key={alertTimeStamp}
      title={t('BATTERY_HEALTH_TITLE', { ns })}
      message={t('BATTERY_HEALTH_MESSAGE', { ns })}
      popoverText={t('BATTERY_HEALTH_POPOVER', { ns })}
      unit={{ key: 'PERCENTAGE_UNIT' }}
      className="health"
      maxValue={99}
      maxValueType='warning'
      warning={props.worldSettings.batteryHealthStatusYellow}
      problem={props.worldSettings.batteryHealthStatusRed}
      dataUpdated={onDataChanged}
      disabled={props.submitInProgress || !props.worldSettings.batteryHealthStatusEnabled}
      alertEnabled={props.worldSettings.batteryHealthStatusEnabled}
      alertToggled={onAlertToggled}
    />
  );
}
